// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"8":"f1e526d4","24":"252706bd","71":"fe64d5f6","93":"8da5411a","249":"a58e750f","620":"405f2ba1","697":"14b05433","828":"1b4b5bad","853":"c503c5fd","943":"1e736d44","976":"21638a25"}[chunkId] + ".js";
};